// pages/About.js
import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const About = () => {
  // Common card style to avoid repetition
  const cardStyle = {
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    border: 'none',
    overflow: 'hidden'
  };

  return (
    <div className="about-container">
      {/* Enhanced Header Section */}
      <div className="about-header text-center mb-8">
        <img src="/logo.png" alt="DIS Logo" className="mx-auto mb-4" />
        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Empowering students with quality education, values, and skills for a brighter future.
          Discover our mission, vision, and commitment to excellence.
        </p>
      </div>

      <div className="about-content">
        {/* NEW: About Us & Curriculum Section */}
        <div className="grid mb-4">
          {/* About Us Card */}
          <div className="col-12 md:col-12 mb-4">
            <Card className="about-card h-full" style={cardStyle}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3">🏫</span>
                  <h3 className="text-2xl font-bold text-primary m-0">About Us</h3>
                </div>
              </div>
              <div className="card-content">
                <p className="text-gray-600 leading-relaxed text-justify">
                  Dream India School, Tiruvuru stands as a landmark institution in the region’s educational
                  landscape. We take immense pride in being the first CBSE-affiliated school in Tiruvuru,
                  marking a historic milestone in the town’s academic journey. Today, we are widely
                  recognized as one of the leading CBSE schools in the entire Tiruvuru region, committed
                  to delivering excellence in education.
                </p>
                <p className="text-gray-600 leading-relaxed text-justify mt-3">
                  Our affiliation with the Central Board of Secondary Education (CBSE) reflects our adherence
                  to national academic standards, structured curriculum design, and competency-based learning
                  practices. From strong foundational instruction to advanced academic preparation, we ensure
                  that our students receive education that is both rigorous and future-oriented.
                </p>
                <p className="text-gray-600 leading-relaxed text-justify mt-3">
                  We have built a team of highly qualified and experienced educators from across India,
                  bringing diverse expertise, innovative teaching methodologies, and a shared passion for
                  nurturing young minds. Our faculty is supported by modern infrastructure, technology-
                  enabled classrooms, and a safe, disciplined campus environment.
                </p>
                <p className="text-gray-600 leading-relaxed text-justify mt-3">
                  At Dream India School, we believe education is not merely about examinations — it is about
                  shaping character, leadership, creativity, and resilience. Our mission is to empower every
                  student to dream big, achieve excellence, and emerge as confident, responsible citizens ready
                  to contribute meaningfully to society.
                </p>
              </div>
            </Card>
          </div>

          {/* Curriculum Card */}
          <div className="col-12 md:col-12 mb-4">
            <Card className="about-card h-full" style={cardStyle}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3">📚</span>
                  <h3 className="text-2xl font-bold text-primary m-0">Curriculum</h3>
                </div>
              </div>
              <div className="card-content">
                <p className="text-gray-600 leading-relaxed text-justify">
                  At Dream India School, Tiruvuru, we follow the curriculum prescribed by the Central
                  Board of Secondary Education (CBSE), ensuring a structured, competency-based, and
                  student-centered academic framework.
                </p>
                <p className="text-gray-600 leading-relaxed text-justify mt-3">
                  The CBSE curriculum emphasizes conceptual understanding, application of knowledge,
                  critical thinking, and skill development. It is designed to move beyond rote learning and
                  encourage experiential, inquiry-based, and interdisciplinary learning practices.
                </p>
                <p className="text-gray-600 leading-relaxed text-justify mt-3">
                  Our academic program focuses on:
                </p>
                <ul className="text-gray-600 leading-relaxed list-disc pl-5 mt-2 text-justify">
                  <li>Strong foundational skills in Languages, Mathematics, Science, and Social Studies</li>
                  <li>Competency-based and activity-oriented teaching methodologies</li>
                  <li>Continuous and comprehensive assessment practices</li>
                  <li>Integration of technology in classroom learning</li>
                  <li>Co-scholastic development through arts, sports, life skills, and value education</li>
                </ul>
                <p className="text-gray-600 leading-relaxed text-justify mt-3">
                  Aligned with national educational standards, our curriculum aims to develop well-rounded
                  individuals who are intellectually competent, socially responsible, and ethically grounded.
                  Through a balanced blend of academics and co-curricular engagement, we prepare our
                  students not only for examinations but for lifelong learning and leadership in an evolving
                  global environment.
                </p>
              </div>
            </Card>
          </div>
        </div>

        {/* Existing Sections */}
        <div className="grid">
          {/* Mission & Vision */}
          <div className="col-12 md:col-12 mb-4">
            <Card className="about-card h-full" style={cardStyle}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3">🎯</span>
                  <h3 className="text-2xl font-bold text-primary m-0">Mission & Vision</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="mission-vision-item mb-4">
                  <div className="flex align-items-start">
                    <span className="mission-icon mr-3">🚀</span>
                    <div>
                      <h4 className="text-lg font-semibold mb-2 text-primary text-left">Mission</h4>
                      <p className="text-gray-600 leading-relaxed text-justify">
                        Dream India Schools envision to contribute towards India’s progress, making quality education affordable and accessible, thus making the nation educated and empowered. The vision encompasses taking DIS to its rightful position, among India’s largest chain of schools.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mission-vision-item">
                  <div className="flex align-items-start">
                    <span className="vision-icon mr-3">👁️</span>
                    <div>
                      <h4 className="text-lg font-semibold mb-2 text-primary text-left">Vision</h4>
                      <p className="text-gray-600 leading-relaxed text-justify">
                        To serve students from all backgrounds, in a safe and supportive environment, working together with teachers and parents, developing self-disciplined adults who will contribute responsibly in a global community.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Parents-Teachers Association */}
          <div className="col-12 md:col-6 mb-4">
            <Card className="about-card h-full" style={cardStyle}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3">🤝</span>
                  <h3 className="text-2xl font-bold text-primary m-0">Parents–Teachers Association</h3>
                </div>
              </div>
              <div className="card-content">
                <p className="text-gray-600 leading-relaxed">
                  PTA fosters collaboration between parents and teachers, creating a strong
                  partnership that supports student success and school development.
                </p>
                <div className="pta-benefits mt-4">
                  <div className="benefit-item">
                    <span className="benefit-icon">💬</span>
                    <span>Regular Communication</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🎯</span>
                    <span>Shared Goals</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🌟</span>
                    <span>Student Support</span>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Annual Report */}
          <div className="col-12 md:col-6 mb-4">
            <Card className="about-card h-full" style={cardStyle}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3">📊</span>
                  <h3 className="text-2xl font-bold text-primary m-0">Annual Report</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="report-stats">
                  <div className="stat-highlight">
                    <div className="stat-number">1100+</div>
                    <div className="stat-label">Students</div>
                  </div>
                  <div className="stat-highlight">
                    <div className="stat-number">50+</div>
                    <div className="stat-label">Teachers</div>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed mt-4">
                  2024-25 Report showcases our achievements in academics and sports,
                  demonstrating our commitment to holistic education.
                </p>
              </div>
            </Card>
          </div>

          {/* Circulars */}
          <div className="col-12 md:col-6 mb-4">
            <Card className="about-card h-full" style={cardStyle}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3">📢</span>
                  <h3 className="text-2xl font-bold text-primary m-0">Circulars</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="circular-item">
                  <span className="circular-icon">📄</span>
                  <span className="circular-text">Latest circulars and announcements available here</span>
                </div>
                <div className="circular-item">
                  <span className="circular-icon">📅</span>
                  <span className="circular-text">Important dates and events</span>
                </div>
                <div className="circular-item">
                  <span className="circular-icon">📋</span>
                  <span className="circular-text">Policy updates and guidelines</span>
                </div>
              </div>
            </Card>
          </div>

          {/* DIS Brochure */}
          <div className="col-12 md:col-6 mb-4">
            <Card className="about-card h-full" style={cardStyle}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3">📖</span>
                  <h3 className="text-2xl font-bold text-primary m-0">DIS Brochure</h3>
                </div>
              </div>
              <div className="card-content">
                <p className="text-gray-600 leading-relaxed mb-4">
                  Download our comprehensive brochure for detailed information about our
                  programs, facilities, and educational approach.
                </p>
                {/* <Button
                  label="Download Brochure"
                  className="download-button"
                  icon="pi pi-download"
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = '/documents/BROCHURE.pdf'; 
                    link.download = 'DIS-Brochure.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                  style={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '0.75rem 1.5rem',
                    boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
                    transition: 'all 0.3s ease'
                  }}
                /> */}
              </div>
            </Card>
          </div>
        </div>
      </div>

      {/* Custom CSS for enhanced styling */}
      <style jsx>{`
        .about-container {
          padding: 2rem;
          background: linear-gradient(135deg, #03397d 0%, #03397d 100%);
          min-height: 100vh;
        }
        
        .about-content {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .about-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
        }
        
        .card-header-enhanced {
          padding: 1.5rem 1.5rem 0 1.5rem;
        }
        
        .card-content {
          padding: 0 1.5rem 1.5rem 1.5rem;
        }
        
        .mission-icon, .vision-icon, .award-icon {
          font-size: 1.5rem;
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        
        .committee-list {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }
        
        .committee-member {
          display: flex;
          align-items: center;
          padding: 0.75rem;
          background: #f8fafc;
          border-radius: 8px;
          border-left: 3px solid #2563eb;
        }
        
        .member-icon {
          font-size: 1.25rem;
          margin-right: 0.75rem;
        }
        
        .member-role {
          font-weight: 500;
          color: #374151;
        }
        
        .pta-benefits {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }
        
        .benefit-item {
          display: flex;
          align-items: center;
          padding: 0.5rem 0.75rem;
          background: #f0f9ff;
          border-radius: 20px;
          font-size: 0.875rem;
          color: #1e40af;
        }
        
        .benefit-icon {
          margin-right: 0.5rem;
        }
        
        .report-stats {
          display: flex;
          gap: 2rem;
          margin-bottom: 1rem;
        }
        
        .stat-highlight {
          text-align: center;
          padding: 1rem;
          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
          border-radius: 12px;
          flex: 1;
        }
        
        .stat-number {
          font-size: 2rem;
          font-weight: bold;
          color: #2563eb;
          margin-bottom: 0.25rem;
        }
        
        .stat-label {
          font-size: 0.875rem;
          color: #64748b;
          font-weight: 500;
        }
        
        .circular-item {
          display: flex;
          align-items: center;
          padding: 0.75rem;
          margin-bottom: 0.75rem;
          background: #f8fafc;
          border-radius: 8px;
          border-left: 3px solid #10b981;
        }
        
        .circular-icon {
          font-size: 1.25rem;
          margin-right: 0.75rem;
        }
        
        .circular-text {
          color: #374151;
          font-size: 0.875rem;
        }
        
        .download-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4) !important;
        }
        
        .newsletter-features {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        
        .feature-tag {
          padding: 0.5rem 0.75rem;
          background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
          border-radius: 20px;
          font-size: 0.75rem;
          color: #92400e;
          font-weight: 500;
        }
        
        @media (max-width: 768px) {
          .about-container {
            padding: 1rem;
          }
          
          .about-header {
            padding: 2rem;
          }
          
          .about-card:hover {
            transform: none;
          }
          
          .report-stats {
            flex-direction: column;
            gap: 1rem;
          }
          
          .pta-benefits {
            flex-direction: column;
          }
          
          .newsletter-features {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default About;